var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGlutenFree(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 18,
    viewBox: "0 0 19 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.5332 17C13.9515 17 17.5332 13.4183 17.5332 9C17.5332 4.58172 13.9515 1 9.5332 1C5.11493 1 1.5332 4.58172 1.5332 9C1.5332 13.4183 5.11493 17 9.5332 17Z",
    stroke: "#81BC45",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.25195 9.0459L9.51862 9.29733L9.5491 9.3278L9.97576 9.74685L10.4253 10.1811",
    stroke: "#81BC45",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15.1085 14.7357L12.1523 11.8633",
    stroke: "#81BC45",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M6.9426 6.78984L3.64355 3.58984",
    stroke: "#81BC45",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M10.6471 5.81403C10.6255 6.20186 10.5031 6.57734 10.292 6.90337C10.0809 7.22941 9.78834 7.49472 9.44329 7.67308C9.08158 7.50456 8.7703 7.24428 8.54039 6.91814C8.31049 6.59199 8.16997 6.21134 8.13281 5.81403C8.2321 4.92777 8.66198 4.11156 9.33662 3.52832C10.0554 4.08971 10.5257 4.91016 10.6471 5.81403V5.81403Z",
    stroke: "#81BC45",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M8.68617 7.48436C8.94636 7.77429 9.12616 8.12726 9.2077 8.50819C9.28923 8.88913 9.26966 9.28476 9.15093 9.65579C8.7803 9.78643 8.38225 9.8193 7.99522 9.75123C7.60818 9.68317 7.24523 9.51647 6.94141 9.26722C6.38596 8.56655 6.11402 7.68276 6.1795 6.79103C7.07331 6.68889 7.97189 6.93743 8.68617 7.48436V7.48436Z",
    stroke: "#81BC45",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M10.0895 7.48495C9.82933 7.77487 9.64953 8.12784 9.568 8.50878C9.48646 8.88971 9.50603 9.28535 9.62476 9.65638C10.0058 9.80133 10.4186 9.84173 10.8205 9.77341C11.2224 9.70509 11.5988 9.53052 11.9105 9.26781C12.4679 8.5682 12.7401 7.6836 12.6724 6.79161C12.2174 6.73167 11.7551 6.76206 11.3119 6.88103C10.8687 7 10.4533 7.20523 10.0895 7.48495V7.48495Z",
    stroke: "#81BC45",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M8.68617 10.4385C8.94636 10.7284 9.12616 11.0814 9.2077 11.4623C9.28923 11.8432 9.26966 12.2389 9.15093 12.6099C8.7803 12.7405 8.38225 12.7734 7.99522 12.7053C7.60818 12.6373 7.24523 12.4706 6.94141 12.2213C6.38596 11.5206 6.11402 10.6369 6.1795 9.74513C7.07331 9.64299 7.97189 9.89154 8.68617 10.4385V10.4385Z",
    stroke: "#81BC45",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M10.0895 10.441C9.82933 10.7309 9.64953 11.0839 9.568 11.4648C9.48646 11.8458 9.50603 12.2414 9.62476 12.6124C10.0058 12.7574 10.4186 12.7978 10.8205 12.7295C11.2224 12.6611 11.5988 12.4866 11.9105 12.2239C12.4679 11.5243 12.7401 10.6397 12.6724 9.74767C12.2174 9.68773 11.7551 9.71812 11.3119 9.83709C10.8687 9.95606 10.4533 10.1613 10.0895 10.441V10.441Z",
    stroke: "#81BC45",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M9.52441 14.5391V7.84961",
    stroke: "#81BC45",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGlutenFree);
export default __webpack_public_path__ + "static/media/gluten_free.021aa8f6a35b2b58dde1a34981f53a10.svg";
export { ForwardRef as ReactComponent };